import { render } from "./MealReservationForm.vue?vue&type=template&id=5be1a094&scoped=true"
import script from "./MealReservationForm.vue?vue&type=script&lang=js"
export * from "./MealReservationForm.vue?vue&type=script&lang=js"

import "./MealReservationForm.vue?vue&type=style&index=0&id=5be1a094&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5be1a094"]])

export default __exports__